import { useQueries } from '@tanstack/react-query';
import type { IMenu } from 'src/types/menu.types';
import { menuQuery } from 'src/hooks/useMenu/useMenu';

// Shares the `useMenu` cache, so a menu that's already been opened isn't fetched again.
export const useMenusById = (menuIds: string[]): { data: IMenu[]; isLoading: boolean } => {
  const queries = useQueries({ queries: menuIds.map(menuQuery) });

  return {
    data: queries.flatMap((query) => (query.data ? [query.data] : [])),
    isLoading: queries.some((query) => query.isLoading),
  };
};
